import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconYandex(rest) {
  return (
    <Icon viewBox="0 0 16 16" {...rest}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        transform="matrix(1 0 0 -1 4.011187 15.842911)"
        d="m8.38162125 15.5352192h-1.28052375c-.113415 0-.18423375-.0571615-.20061375-.140023-.0162375-.0831847-1.92034875-6.04235389-2.05872375-6.53872697-.0981225-.35193846-.41807625-1.59255-.49483125-1.89045385l-.6622125 1.85578847c-.1609125.51078077-1.70320125 4.93328465-1.748445 5.10997695-.0249375.0971154-.0684.2178423-.23422875.2178423h-1.250175c-.12222375 0-.191415-.1376231-.1519425-.2229654.031425-.0683692 2.289675-6.23473462 3.20196-8.59041924v-5.17938461c0-.09447308.036825-.15115385.1286175-.15115385h1.18403625c.0734025 0 .12846375.05668077.12846375.15115385v4.90982307.22873462c.7605 2.18002692 3.53837625 9.93518076 3.56856375 10.02196536.0369.1060769.0260625.2178423-.129945.2178423z"
      />
    </Icon>
  )
}
